import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';
import ItemLoading from '../slider/item-loading/item-loading';
import getThumbnailMinWidthAttribute from '../slider/get-thumbnail-min-width-attribute';
import styles from './thumbnail.scss';
import { DollarIcon } from '../../../icons/compiled';
import { Picture } from '../../../components';
const THUMBNAIL_RATIO = 9 / 16;
class Thumbnail extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "stopPropagation", event => {
      event.stopPropagation();
    });
  }
  getCoverStyle() {
    return {
      ...this.getSize(),
      backgroundImage: "url(" + this.props.backgroundUrl + ")"
    };
  }
  getSize() {
    const {
      width
    } = this.props;
    if (width) {
      const height = width * THUMBNAIL_RATIO;
      return {
        width,
        height
      };
    }
    return {};
  }
  getMinWidthAttributte() {
    const {
      width
    } = this.props;
    if (width) {
      return {
        'data-thumbnail-min-width': getThumbnailMinWidthAttribute(width)
      };
    }
    return {};
  }
  renderLiveLabel() {
    const {
      width,
      showLiveLabel,
      liveLabel,
      isRTL
    } = this.props;
    if (!showLiveLabel) {
      return null;
    }
    const liveLabelStyles = classnames(styles['live-label'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: liveLabelStyles
    }, /*#__PURE__*/React.cloneElement(liveLabel, {
      thumbnailWidth: width
    }));
  }
  renderButtons() {
    const {
      buttons,
      isRTL
    } = this.props;
    if (!buttons) {
      return null;
    }
    const buttonsStyles = classnames(styles.buttons, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      onClick: this.stopPropagation,
      className: buttonsStyles
    }, buttons);
  }
  getCoverClassName() {
    const {
      showLiveLabel,
      showButtonsOnHover,
      isRTL
    } = this.props;
    return classnames(styles.thumbnail, {
      [styles['show-live-label']]: showLiveLabel,
      [styles['buttons-on-hover']]: showButtonsOnHover,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
  }
  renderContent() {
    const {
      content,
      isRTL
    } = this.props;
    if (!content) {
      return null;
    }
    const contentStyle = classnames(styles.content, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: contentStyle
    }, content);
  }
  renderDuration() {
    const {
      duration,
      isRTL
    } = this.props;
    if (!duration) {
      return null;
    }
    const durationStyles = classnames(styles.duration, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: durationStyles
    }, duration);
  }
  render() {
    const {
      width,
      onClick,
      overlayClassName,
      isFocusable,
      isLoading,
      ariaLabel,
      dataHook,
      isRTL,
      isPaid,
      useResponsiveThumbnail,
      backgroundSrc,
      breakpoints,
      videoTitle
    } = this.props;
    const containerStyle = classnames(styles.container, {
      [styles.loading]: isLoading,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL,
      [styles.stretch]: Boolean(breakpoints)
    });
    const wrapperStyle = classnames(styles.wrapper, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const loaderStyle = classnames(styles.loader, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const overlayStyle = classnames(styles.overlay, overlayClassName, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL,
      [styles.absolute]: useResponsiveThumbnail
    });
    const overlay = /*#__PURE__*/React.createElement("div", {
      className: overlayStyle
    }, this.renderLiveLabel(), this.renderButtons(), this.renderDuration(), isPaid && /*#__PURE__*/React.createElement(DollarIcon, {
      className: styles.paidIcon
    }));
    const pictureWidth = width || 320;
    const pictureBreakpoints = breakpoints || [{
      min: 0,
      width: pictureWidth,
      height: pictureWidth / 16 * 9
    }];
    return /*#__PURE__*/React.createElement("div", _extends({}, this.getMinWidthAttributte(), {
      style: {
        width
      },
      className: containerStyle,
      onClick: onClick,
      "data-hook": dataHook,
      "aria-hidden": !isFocusable
    }), /*#__PURE__*/React.createElement("div", {
      className: wrapperStyle,
      tabIndex: isFocusable ? 0 : -1,
      "aria-label": ariaLabel
    }, isLoading ? /*#__PURE__*/React.createElement("div", {
      className: loaderStyle,
      style: this.getSize()
    }, /*#__PURE__*/React.createElement(ItemLoading, {
      active: isLoading
    })) : /*#__PURE__*/React.createElement("div", {
      className: this.getCoverClassName(),
      "data-hook": "thumbnail-cover",
      style: useResponsiveThumbnail ? {} : this.getCoverStyle()
    }, useResponsiveThumbnail ? /*#__PURE__*/React.createElement(Picture, {
      alt: videoTitle,
      src: backgroundSrc,
      breakpoints: pictureBreakpoints
    }, overlay) : overlay), this.renderContent()));
  }
}
_defineProperty(Thumbnail, "displayName", 'Thumbnail');
_defineProperty(Thumbnail, "defaultProps", {
  onClick: noop,
  dataHook: 'video-list-thumb-wrapper'
});
export default Thumbnail;
//# sourceMappingURL=thumbnail.js.map